import { ColumnsType } from 'antd/es/table';

export const headerOrderReg: ColumnsType<any> = [
  {
    title: 'Mã khu vực',
    dataIndex: 'area_code',
  },
  {
    title: 'Mã cửa hàng',
    dataIndex: 'plant_code',
  },
  {
    title: 'Tên cửa hàng',
    dataIndex: 'plant_name',
  },
  {
    title: 'Dòng hàng SAP',
    dataIndex: 'line_sap_text',
  },
  {
    title: 'Mã giỏ hàng',
    dataIndex: 'cart_code',
  },
  {
    title: 'Tên giỏ hàng',
    dataIndex: 'cart_name',
  },
  {
    title: 'Loại giỏ hàng',
    dataIndex: 'cart_type_name',
  },
  {
    title: 'Người khai báo',
    dataIndex: 'created_by',
  },
  {
    title: 'Ngày bắt đầu',
    dataIndex: 'date_started',
  },
  {
    title: 'Ngày hết hạn',
    dataIndex: 'date_end',
  },
  {
    title: 'Ngày khai báo',
    dataIndex: 'created_at',
  },
  {
    title: 'Ngày gửi yêu cầu phê duyệt',
    dataIndex: 'request_date',
  },
  {
    title: 'Tủ xman',
    dataIndex: 'line_xman_text',
  },
  {
    title: 'Product Family',
    dataIndex: 'product_family',
  },
  {
    title: 'Mã mẫu/SP',
    dataIndex: 'ma_mau',
  },
  {
    title: 'Tên sản phẩm',
    dataIndex: 'ten_mau',
  },
  {
    title: 'Min DK',
    dataIndex: 'order_min',
  },
  {
    title: 'Max DK',
    dataIndex: 'order_max',
  },
  {
    title: 'Vốn Min KH',
    dataIndex: 'capital_min',
  },
  {
    title: 'Vốn Max KH',
    dataIndex: 'capital_max',
  },
  {
    title: 'Tồn kho hiện tại',
    dataIndex: 'tongsl_ton',
  },
  {
    title: 'Aging CH',
    dataIndex: 'aging_ch',
  },
  {
    title: 'Doanh thu 6 tháng',
    dataIndex: 'doanhthu_6th',
  },
  {
    title: 'Doanh số 6 tháng',
    dataIndex: 'doanhso_6th',
  },
  {
    title: 'TB Doanh thu 6 tháng',
    dataIndex: 'tb_doanhthu_6th',
  },
  {
    title: 'TB Doanh số 6 tháng',
    dataIndex: 'tb_doanhso_6th',
  },
  {
    title: 'Doanh thu kỳ vọng KV',
    dataIndex: 'doanh_thu_kv_kv',
  },
  {
    title: 'Doanh số kỳ vọng KV',
    dataIndex: 'doanh_so_ki_vong_kv',
  },
  {
    title: 'Doanh thu kỳ vọng TQ',
    dataIndex: 'doanh_thu_ky_vong_tq_vnd',
  },
  {
    title: 'Doanh số kỳ vọng TQ',
    dataIndex: 'doanh_so_ky_vong_tq_mon',
  },
  {
    title: 'Giá vốn',
    dataIndex: 'cost_price',
  },
  {
    title: 'Giá bán',
    dataIndex: 'price',
  },
  {
    title: 'PLHH',
    dataIndex: 'plhh',
  },
  {
    title: 'Ngành hàng',
    dataIndex: 'nganh_hang',
  },
  {
    title: 'Dòng hàng',
    dataIndex: 'dong_hang',
  },
  {
    title: 'Chủng loại',
    dataIndex: 'chung_loai',
  },
  {
    title: 'Nhóm đặc biệt',
    dataIndex: 'nhom_dac_biet',
  },
  {
    title: 'BST',
    dataIndex: 'bst_text',
  },
  {
    title: 'Bộ',
    dataIndex: 'zma_bo_text',
  },
  {
    title: 'Cặp',
    dataIndex: 'zma_ts_cap_text',
  },
  {
    title: 'Đánh giá KV',
    dataIndex: 'danh_gia_kv',
  },
  {
    title: 'Đánh giá TQ',
    dataIndex: 'danh_gia_tq',
  },
  {
    title: 'Phân nhóm',
    dataIndex: 'phan_nhom',
  },
  {
    title: 'Giới tính',
    dataIndex: 'gioitinh_text',
  },
  {
    title: 'Tuổi vàng',
    dataIndex: 'purity_of_gold',
  },
  {
    title: 'Size',
    dataIndex: 'size',
  },
  {
    title: 'Màu sắc',
    dataIndex: 'color',
  },
];
